import * as angular from 'angular';

// Directives
import AdjustHeightDirective from './adjustHeight.directive';
import AptitudeDialGauge from './aptitudeDialGauge.component';
import AptitudeLoadingGaugeDirective from './aptitudeLoadingGauge.directive';
import AptitudeSavingsDisplay from './aptitudeSavingsDisplay.component';
import AptitudeStopScrollEventBubble from './aptitudeStopScrollEventBubble.directive';
import AptValidity from './aptValidity.directive';
import FixedHeaderDirective from './fixedHeader.directive';
import HtmlCompileDirective from './htmlCompile.directive';
import OfferTypeDirective from './offerType.directive';
import OnChangeCommitDirective from './onChangeCommit.directive';
import {
  PopoverHtmlUnsafe,
  PopoverHtmlUnsafePopup
} from './popoverHtmlUnsafe.directive';
import ScrollableTableBodyDirective from './scrollableTableBody.directive';

// Buyer services
import AddSellerToPlanService from './services/addSellerToPlan.service';
import EditReleasedPlanService from './services/editReleasedPlan.service';
import GetAllXrefsForProductAndSellerService from './services/getAllXrefsForProductAndSeller.service';
import GetMainPurchasePlanIdFromRFPId from './services/getMainPurchasePlanIdFromRFPId.service';
import GetMixesService from './services/getMixes.service';
import GetPartnerPlanFromMaster from './services/getPartnerPlanIdFromMasterPlanId.service';
import GetPricingComparisonForBuyerForSellerTermService from './services/getPricingComparisonForBuyerForSellerTerm.service';
import GetProductsForUnspscService from './services/getProductsForUnspsc.service';
import GetPurchasePlanDetailService from './services/getPurchasePlanDetail.service';
import GetSellerPotentialService from './services/getSellerPotential.service';
import GetSupportedTermsForBuyerService from './services/getSupportedTerms.service';
import GetXrefsForProductService from './services/getXrefsForProduct.service';
import LoadMixService from './services/loadMix.service';
import OptimizeMixForSellerService from './services/optimizeMixForSeller.service';
import ReleasePlanService from './services/releasePlan.service';
import RemoveSellerFromPlanService from './services/removeSellerFromPlan.service';
import RemoveSellerResponse from './services/removeSellerResponse.service';
import SelectXrefsForProductAndSellerService from './services/selectXrefsForProductAndSeller.service';
import SetContractEffectiveDate from './services/setContractEffectiveDate.service';
import SetInclusionFlagAllMembers from './services/setInclusionFlagAllMembers.service';
import SetMemberInclusionFlag from './services/setMemberInclusionFlag.service';
import UpdateTargetsService from './services/updateTargets.service';
import UpdateXrefsForProductService from './services/updateXrefsForProduct.service';

// Other
import { CommonResourceURL } from './commonResourceUrl.const';
import GoogleAnalyticsService from './googleAnalytics.service';
import LegacyCompareRFIApi from './compareRFIApi.service';
import WindowMonitor from './windowMonitor.factory';

export default angular
  .module('aptitude', [])

  .directive('adjustHeight', AdjustHeightDirective)
  .directive('aptitudeDialGauge', AptitudeDialGauge)
  .directive('aptitudeLoadingGauge', AptitudeLoadingGaugeDirective)
  .directive('aptitudeSavingsDisplay', AptitudeSavingsDisplay)
  .directive('aptitudeStopScrollEventBubble', AptitudeStopScrollEventBubble)
  .directive('aptValidity', AptValidity)
  .directive('fixedHeader', FixedHeaderDirective)
  .directive('htmlCompile', HtmlCompileDirective)
  .directive('offerType', OfferTypeDirective) // Still used?
  .directive('onChangeCommit', OnChangeCommitDirective)
  .directive('popoverHtmlUnsafe', PopoverHtmlUnsafe) // Still used?
  .directive('popoverHtmlUnsafePopup', PopoverHtmlUnsafePopup) // Still used?
  .directive('scrollableTableBody', ScrollableTableBodyDirective)

  // buyer services
  .service('addSellerToPlanService', AddSellerToPlanService)
  .service('editReleasedPlanService', EditReleasedPlanService)
  .service(
    'getAllXrefsForProductAndSellerService',
    GetAllXrefsForProductAndSellerService
  )
  .service('getMainPurchasePlanIdFromRFPId', GetMainPurchasePlanIdFromRFPId)
  .service('getMixesService', GetMixesService)
  .service('getPartnerPlanFromMaster', GetPartnerPlanFromMaster)
  .service(
    'getPricingComparisonForBuyerForSellerTermService',
    GetPricingComparisonForBuyerForSellerTermService
  )
  .service('getProductsForUnspscService', GetProductsForUnspscService)
  .service('getPurchasePlanDetailService', GetPurchasePlanDetailService)
  .service('getSellerPotentialService', GetSellerPotentialService)
  .service('getSupportedTermsForBuyerService', GetSupportedTermsForBuyerService)
  .service('getXrefsForProductService', GetXrefsForProductService)
  .service('loadMixService', LoadMixService)
  .service('optimizeMixForSellerService', OptimizeMixForSellerService)
  .service('releasePlanService', ReleasePlanService)
  .service('removeSellerFromPlanService', RemoveSellerFromPlanService)
  .service('removeSellerResponse', RemoveSellerResponse)
  .service(
    'selectXrefsForProductAndSellerService',
    SelectXrefsForProductAndSellerService
  )
  .service('setContractEffectiveDate', SetContractEffectiveDate)
  .service('setInclusionFlagAllMembers', SetInclusionFlagAllMembers)
  .service('setMemberInclusionFlag', SetMemberInclusionFlag)
  .service('updateTargetsService', UpdateTargetsService)
  .service('updateXrefsForProductService', UpdateXrefsForProductService)

  .value('commonResourceURL', CommonResourceURL)
  .service('GoogleAnalytics', GoogleAnalyticsService) // ???
  .service('legacyCompareRFIApi', LegacyCompareRFIApi)
  .factory('WindowMonitor', WindowMonitor).name;
